import { useAppState } from "@pimo/pimo-app-builder/src/lib/app-state-context";

/* eslint-disable @typescript-eslint/no-explicit-any */

export function usePimoForm<AppStateSliceType>({
  appStateSlice,
}: {
  appStateSlice: string;
}): {
  formState: AppStateSliceType;
  setValue: (key: string, value: unknown) => void;
} {
  const appState = useAppState();

  return {
    formState:
      getPathInObject(appState, appStateSlice) ?? ({} as AppStateSliceType),
    setValue: (key: string, value: unknown) => {
      const appStateSliceValue =
        (useAppState.getState()[appStateSlice] as AppStateSliceType) ?? {};

      const newAppStateSliceValue = {
        ...appStateSliceValue,
      };

      setPathInObject(newAppStateSliceValue, key, value);

      useAppState.setState({ [appStateSlice]: newAppStateSliceValue });
    },
  };
}

function setPathInObject(object: any, path: string, value: unknown) {
  const pathParts = path.split(".").reverse();

  let objectForCurrentPathPart: any = object;

  let nextObject = object;
  while (pathParts.length > 1) {
    const pathPart = pathParts.pop();

    if (!pathPart) {
      return;
    }

    nextObject = objectForCurrentPathPart[pathPart];

    if (!nextObject) {
      objectForCurrentPathPart[pathPart] = {};
      nextObject = objectForCurrentPathPart[pathPart];
    }

    if (typeof nextObject !== "object") {
      break;
    }

    objectForCurrentPathPart = nextObject;
  }

  nextObject[pathParts[0]] = value;
}

function getPathInObject(object: any, path: string) {
  const pathParts = path.split(".");

  let nextObject = object;
  for (const pathPart of pathParts) {
    nextObject = nextObject[pathPart];
    if (!nextObject) {
      return;
    }
  }

  return nextObject;
}
